class ProductVideoGallery extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      yt_player: this.querySelector('#yt-player'),
      yt_player_title: this.querySelector('#yt-player__video-title'),
      yt_player_description: this.querySelector('#yt-player__video-description'),
      yt_videos: this.querySelectorAll('.category-video'),
    };

    this.playerInstance = null;

    this.loadIframeApi = this.loadIframeApi.bind(this);
    this.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);
    this.loadVideo = this.loadVideo.bind(this);
    this.scrollToVideoPlayer = this.scrollToVideoPlayer.bind(this);

    Array.from(this.elements.yt_videos).forEach((el) => el.addEventListener('click', this.loadVideo));
    window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady;

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (entries[0].isIntersecting) {
          this.loadIframeApi();
          observer.disconnect();
        }
      },
      { rootMargin: '0px 0px 150px 0px' }
    );

    this.observer.observe(this);
  }

  loadIframeApi() {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  onYouTubeIframeAPIReady() {
    let ytid = null;
    if (!!this.elements.yt_player) ytid = this.elements.yt_player.dataset.ytid;

    //If there are product videos, load the first's info into the player
    if (this.elements.yt_videos.length > 0) {
      this.playerInstance = new YT.Player(this.elements.yt_player, {
        height: '360',
        width: '640',
        videoId: this.elements.yt_videos[0].dataset.id,
        playerVars: {
          autoplay: '0',
          controls: '2',
          rel: '0',
          showinfo: '0',
        },
      });
      this.elements.yt_player_title.textContent = this.elements.yt_videos[0].dataset.title;
      this.elements.yt_player_description.textContent = this.elements.yt_videos[0].dataset.description;
    } else if (!!ytid) {
      this.playerInstance = new YT.Player('yt-player', {
        height: '360',
        width: '640',
        videoId: ytid,
      });
    }
  }

  loadVideo(e) {
    e.preventDefault();
    const data = e.currentTarget.dataset;
    this.playerInstance.loadVideoById(data.id, 0, 'large');
    this.elements.yt_player_title.textContent = data.title;
    this.elements.yt_player_description.textContent = data.description;
    this.scrollToVideoPlayer();
  }

  scrollToVideoPlayer() {
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

customElements.define('product-video-gallery', ProductVideoGallery);
